<template>
  <div>
    <div>
      <span class="xbed-sub-title">结算账单报表</span>
    </div>
    
    <div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>报表</BreadcrumbItem>
				<BreadcrumbItem>结算账单报表</BreadcrumbItem>
			</Breadcrumb>
		</div>
    <br>
    <Tabs style="width:1628px;" @on-click="handleTabs" v-model="currentTab">
      <TabPane label="账单明细" name="1" :disabled="!tab1">
        <bill-details v-if="currentTab === '1'" :subjectData="subjectData" :payTypeData="payTypeData" :allHotels="allHotels" :checkoutMonth="checkoutMonth" @getCloseMonth="getCheckoutMonth"></bill-details>
      </TabPane>
      <TabPane label="月度结算汇总" name="2" :disabled="!tab2">
        <monthly-summary v-if="currentTab === '2'" :allHotels="allHotels" :checkoutMonth="checkoutMonth"></monthly-summary>
      </TabPane>
      <TabPane label="手工入账记录" name="3" :disabled="!tab3">
        <manual-entry-record v-if="currentTab === '3'" :subjectData="subjectData" :allHotels="allHotels" :checkoutMonth="checkoutMonth" @getCloseMonth="getCheckoutMonth"></manual-entry-record>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
import billDetails from "./bill-details";
import monthlySummary from "./monthly-summary";
import manualEntryRecord from "./manual-entry-record";

export default {
	created() {
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.headerENV = Utils.aliHeaderEnv(this.env)    
    this.tab1 = Utils.hasPermission( 'oms_accountBill_settlementBillsReport' )
    this.tab2 = Utils.hasPermission( 'oms_accountBill_settlementMonthReport' )
    this.tab3 = Utils.hasPermission( 'manualRecord_list' )
	},

  data () {
    return {
      currentTab: '0',
      subjectData: [ // 科目数据
        {
          value: 0,
          label: '全部',
        }
      ],
      payTypeData: [], // 支付方式下拉数据
      allHotels: [], // 所有门店
      checkoutMonth: [], // 结账月份
    }
  },

  components: {
    'bill-details': billDetails,
    'monthly-summary': monthlySummary,
    'manual-entry-record': manualEntryRecord
  },

  mounted() {
    this.firstLevelData()
    this.getInitialData()
    setTimeout(() => {
      if ( this.tab1 ) {
        this.currentTab = '1'
      } else if (!this.tab1 && this.tab2) {
        this.currentTab = '2'
      } else if (!this.tab1 && !this.tab2 && this.tab3) {
        this.currentTab = '3'
      }
    }, 500);
  },

  methods: {
    // 切换tabs
    handleTabs(name) {
      this.currentTab = name
    },

    /**
    * 一级/二级科目数据 & 支付方式数据
    * @param params 需要传给接口的参数
    * @param type 1是一级科目，2是二级科目，3是支付方式
    */
    async getDictValueList(options) {
      if (!options) {
        return
      }
      let _param = {
        pageNum: 1,
        pageSize: 9999, // 查询所有的一级科目
      }
      options.params = {...options.params, ..._param}
      const resp = (await API.omsAPI[this.env].clientServer.dictValueList(options.params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      if (resp.list && resp.list.length) {
        if (options.type === 1 || options.type === 2) {
          resp.list.map(item => {
            // 一级科目
            if (options.type === 1) {
              let _subject = {
                value: item.id, // 以及科目的id对应的是二级科目的parentId
                label: item.dictDesc,
                children: [],
                dictValue: item.dictValue
              }
              this.subjectData = [...this.subjectData, _subject]

            } else if (options.type === 2 && this.subjectData && this.subjectData.length) {
              // 二级科目
              this.subjectData.map(sub => {
                if (item.parentId === sub.value) {
                  let _subject2 = {
                    value: item.id,
                    label: item.dictDesc,
                    dictValue: item.dictValue
                  }
                  sub.children = [...sub.children, _subject2]
                }
              })
            }
          })
          // 请求一级科目时的回调
          options.type === 1 ? options.callback && options.callback(resp.list) : ''

        } else if (options.type === 3) {
          this.payTypeData = resp.list
        }
        
      }
    },

    // 一级/二级科目数据
    async firstLevelData() {
      this.getDictValueList({
        params: {
          groupId: 31 // 传31查询一级科目，传32查询二级科目
        },
        type: 1,
        callback: () => {
          this.getDictValueList({
            params: {
              groupId: 32 // 传31查询一级科目，传32查询二级科目
            },
            type: 2
          })
        }
      })
    },

    /**
    * 结账月份列表
    * @param type 结算状态：结账状态(0正常,1已关账)，获取全部则不需要传
    */
    async getCheckoutMonth(isClose, callback) {
      let param = isClose ? { state: 0 } : {}
      const MonthResp = (await API.omsAPI[this.env].clientServer.getAccountDateList(param, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
			if ( !MonthResp ) {
				this.$Notice.error( {
					title: '获取结账月份数据异常',
					desc: MonthResp.msg
				})
				return
			}
      if (isClose) {
        callback && callback(MonthResp)
      } else {
        this.checkoutMonth = MonthResp || []
      }
    },

    // 结账月份列表 && 获取所有门店数据 && 支付方式选择框数据
    async getInitialData () {
      // 结账月份列表
      this.getCheckoutMonth()

      // 所有门店数据
      let allHotelsResp = (await API.omsAPI[this.env].php.queryChainByCity()).data
      this.allHotels = allHotelsResp.data;

      // 支付方式选择框数据
      this.getDictValueList({
        params: {
          groupId: 1 // 1是支付方式
        },
        type: 3
      })
    },
  }

}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/report/bill-statement/index.vue